import { PHOTO_UPLOADS_ENABLED } from "@shared/constants/features";

/**
 * Round child avatar: the uploaded photo, or a gradient initial of the nickname.
 *
 * While PHOTO_UPLOADS_ENABLED is false (BRIEF §5.3: no children's photos) it
 * ALWAYS draws the initial, even if a caller hands it a `photoUrl`. The server
 * already withholds photos; this keeps a stale cache or a mock from ever
 * putting a child's face on screen.
 */
export function ChildAvatar({
  name,
  photoUrl,
  className = "h-11 w-11",
  textClassName = "text-base",
}: {
  name: string;
  photoUrl?: string | null;
  className?: string;
  textClassName?: string;
}) {
  if (PHOTO_UPLOADS_ENABLED && photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={name}
        className={`${className} rounded-full object-cover ring-1 ring-neutral-200`}
      />
    );
  }
  const initial = name.trim().charAt(0).toUpperCase() || "?";
  return (
    <span
      className={`${className} ${textClassName} inline-flex items-center justify-center rounded-full bg-gradient-to-br from-sky-100 to-indigo-100 font-display font-semibold text-sky-700`}
    >
      {initial}
    </span>
  );
}
